import {
    IconNotes,
} from '@tabler/icons-react'
import { type SidebarData } from '../types'
import { BugIcon, FileCheckIcon, FileIcon, HomeIcon } from 'lucide-react'

export const applicantSidebarData: SidebarData = {
    user: {
        name: '',
        email: '',
        avatar: '/avatars/shadcn.jpg',
    },

    navGroups: [
        {
            title: 'General',
            items: [
                {
                    title: 'Home',
                    url: '/',
                    icon: HomeIcon,
                },

                {
                    title: 'POPIA',
                    url: '/popia',
                    icon: FileCheckIcon,
                }, {
                    title: 'Important Notices',
                    url: '/important-notices',
                    icon: IconNotes,
                },
                {
                    title: 'Application',
                    icon: FileIcon,
                    url: '/application'
                },
                {
                    title: 'Report an Error',
                    icon: BugIcon,
                    url: '/report-error'
                },
            ],
        },



    ],
}
